<template lang="pug">
  .new-delivery
    shForm(title="New Delivery")
</template>

<script>
import shForm from '@/components/pages/delivery/Form'

export default {
  name: 'NewDelivery',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-delivery
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/delivery/New.vue